import { MAG_DOOR_STATUS, MAG_LOCK_STATUS } from '../../utils/constants'
import { Redirect, Route, Switch } from 'react-router-dom'
import SplashMessage from './SplashMessage'
import SplashButton from './SplashButton'
import SplashSlides from './SplashSlides'
import { useState } from 'react'
import './style.scss'

const INIT_MAGS = [{
  lock: MAG_LOCK_STATUS.locked,
  door: MAG_DOOR_STATUS.closed,
  desc: 'selfStorageOnlineNow',
}, {
  lock: MAG_LOCK_STATUS.locked,
  door: MAG_DOOR_STATUS.closed,
  desc: `chooseYourStorage.${process.env.REACT_APP_TYPE}`,
}, {
  lock: MAG_LOCK_STATUS.locked,
  door: MAG_DOOR_STATUS.closed,
  desc: 'fillDetailsAndPayOnline',
}, {
  lock: MAG_LOCK_STATUS.locked,
  door: MAG_DOOR_STATUS.closed,
  desc: 'manageRemotely',
}]

const message = <SplashMessage />

const SplashScreen = ({ close }) => {
  const [mags, setMags] = useState(INIT_MAGS)

  return (
    <div className='splash'>
      <div className='splash__logo'>
        <i className='icon icon--logo s32' />
      </div>

      <Switch>
        <Route exact path={['/splash/:number', '/splash']}>
          <SplashSlides mags={mags} />

          <div className='splash__footer center'>
            {message}
            <SplashButton
              mags={mags}
              close={close}
              setMags={setMags} />
          </div>
        </Route>
        <Redirect to='/splash' />
      </Switch>
    </div>
  )
}

export default SplashScreen